import React, {useState, useEffect} from "react";
import {
  Table,
  Container,
  Row,
  Col,
  Form,
  Pagination,
  Modal,
  Button
} from "react-bootstrap";
import {connect} from "react-redux";
import AppSpinner from "../AppSpinner/AppSpinner";
import apiUrl from "../../utils/apiUrl";
import formatMoney from "../../utils/formatMoney";
import PaymentDetailComponent from "./PaymentDetail";
import "./styles/payments.scss";
import {saveAs} from "file-saver";

const select = (state) => {
  return {
    token: state.auth.token
  };
};

function ConnectedPayments(props) {
  const {token} = props;
  const [isLoading, setLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [payments, setPayments] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState({});
  const [fetchIndex, setFetchIndex] = useState(0);
  const [methodFilter, setMethodFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);
  const [typeFilter, setTypeFilter] = useState(null);
  const [raceFilter, setRaceFilter] = useState(null);

  useEffect(() => {
    async function getPayments() {
      const filters = {
        status: "APPROVED"
      };

      if (methodFilter) filters.paymentMethod = methodFilter;
      if (statusFilter) filters.status = statusFilter;
      if (typeFilter) filters.type = typeFilter;
      if (raceFilter) filters.detail = raceFilter;

      const dataResponse = await fetch(
        `${apiUrl}/admin/payments/filtered?token=${token}&index=${fetchIndex}&filters=${JSON.stringify(
          filters
        )}`
      );
      const dataJson = await dataResponse.json();
      if (dataJson.payments) setPayments(dataJson.payments);
      setLoading(false);
    }
    getPayments();
  }, [methodFilter, statusFilter, typeFilter, raceFilter, fetchIndex, token]);

  async function downloadFile() {
    fetch(`${apiUrl}/export/donations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then((resp) => resp.json())
      .then((json) => {
        if (json && json.success) {
          const byteCharacters = window.atob(json.data);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          saveAs(blob, "Donaciones.xlsx");
        } else {
          alert("Error. Inténtalo nuevamente.");
        }
      });
  }

  if (isLoading) return <AppSpinner />;

  return (
    <Container fluid>
      <Row>
        <Col>
          <Row>
            <Col>
              <h1>Pagos</h1>
            </Col>
            <Col>
              <Button onClick={() => downloadFile()}>
                Descargar donaciones mes actual
              </Button>
            </Col>
          </Row>

          <hr />

          <Pagination>
            <Pagination.First
              disabled={fetchIndex === 0}
              onClick={() => setFetchIndex(0)}
            />
            <Pagination.Prev
              disabled={fetchIndex === 0}
              onClick={() => setFetchIndex(fetchIndex - 1)}
            />

            <Pagination.Item
              disabled={fetchIndex === 0}
              onClick={() => setFetchIndex(fetchIndex - 1)}
            >
              {fetchIndex}
            </Pagination.Item>
            <Pagination.Item active>{fetchIndex + 1}</Pagination.Item>
            <Pagination.Item onClick={() => setFetchIndex(fetchIndex + 1)}>
              {fetchIndex + 2}
            </Pagination.Item>

            <Pagination.Next onClick={() => setFetchIndex(fetchIndex + 1)} />
            <Pagination.Last onClick={() => setFetchIndex(fetchIndex + 1)} />
          </Pagination>

          <Table striped bordered hover size="sm" className="paymentTable">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>
                  <Form.Control
                    size="sm"
                    as="select"
                    className="paymentFilterSelect"
                    onChange={(e) =>
                      setTypeFilter(
                        e.target.value === "0" ? null : e.target.value
                      )
                    }
                  >
                    <option value="0">Tipo</option>
                    <option value="ONE_TIME_DONATION">Donación</option>
                    <option value="PRODUCT_SALE">Compra de producto</option>
                    <option value="WALLET">Wallet</option>
                  </Form.Control>
                </th>
                <th>Nombre usuario</th>
                <th>Email</th>
                <th>
                  <Form.Control
                    size="sm"
                    as="select"
                    className="paymentFilterSelect"
                    onChange={(e) =>
                      setRaceFilter(
                        e.target.value === "0" ? null : e.target.value
                      )
                    }
                  >
                    <option value="0">Carrera 2020</option>
                    <option value="SALVEMOS_EL_2020_CARRERA">Sí</option>
                  </Form.Control>
                </th>
                <th>Total</th>
                <th>
                  <Form.Control
                    size="sm"
                    as="select"
                    className="paymentFilterSelect"
                    onChange={(e) =>
                      setMethodFilter(
                        e.target.value === "0" ? null : e.target.value
                      )
                    }
                  >
                    <option value="0">Método</option>
                    <option value="CARD">CARD</option>
                    <option value="PSE">PSE</option>
                    <option value="WALLET_PAYMENT">WALLET</option>
                  </Form.Control>
                </th>
                <th>
                  <Form.Control
                    size="sm"
                    as="select"
                    className="paymentFilterSelect"
                    onChange={(e) =>
                      setStatusFilter(
                        e.target.value === "0" ? null : e.target.value
                      )
                    }
                  >
                    <option value="0">Estado</option>
                    <option value="APPROVED">APPROVED</option>
                    <option value="PENDING">PENDING</option>
                    <option value="DECLINED">DECLINED</option>
                  </Form.Control>
                </th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, i) => (
                <tr
                  key={i}
                  onClick={() => {
                    setSelectedPayment(payment);
                    setShowDetails(true);
                  }}
                  style={{cursor: "pointer"}}
                >
                  <td>{new Date(payment.datePayed).toLocaleString()}</td>
                  <td>
                    {payment.programInfo
                      ? payment.programInfo.name
                      : payment.productInfo
                      ? payment.productInfo.name
                      : payment.foundationInfo
                      ? payment.foundationInfo.name
                      : "Wallet Nibi"}
                  </td>
                  <td>
                    {payment.userInfo.firstName +
                      " " +
                      payment.userInfo.lastName}
                  </td>
                  <td>{payment.userInfo.email}</td>
                  <td>{payment.stravaInfo && "Sí"}</td>
                  <td>{formatMoney(payment.amount)}</td>
                  <td>{payment.paymentMethod}</td>
                  <td>{payment.status}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Pagination>
            <Pagination.First
              disabled={fetchIndex === 0}
              onClick={() => setFetchIndex(0)}
            />
            <Pagination.Prev
              disabled={fetchIndex === 0}
              onClick={() => setFetchIndex(fetchIndex - 1)}
            />

            <Pagination.Item
              disabled={fetchIndex === 0}
              onClick={() => setFetchIndex(fetchIndex - 1)}
            >
              {fetchIndex}
            </Pagination.Item>
            <Pagination.Item active>{fetchIndex + 1}</Pagination.Item>
            <Pagination.Item onClick={() => setFetchIndex(fetchIndex + 1)}>
              {fetchIndex + 2}
            </Pagination.Item>

            <Pagination.Next onClick={() => setFetchIndex(fetchIndex + 1)} />
            <Pagination.Last onClick={() => setFetchIndex(fetchIndex + 1)} />
          </Pagination>
        </Col>
      </Row>

      <Modal
        size="lg"
        show={showDetails}
        onHide={() => setShowDetails(false)}
        centered
      >
        <Modal.Body>
          <PaymentDetailComponent payment={selectedPayment} />
        </Modal.Body>
      </Modal>
    </Container>
  );
}

const Payments = connect(select)(ConnectedPayments);

export default Payments;
